import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    maxWidth: 400,
    fontSize: 15,
  },
  btnRoot: {
    color: '#FFFFFF',
    minWidth: 'auto',
  },
}))

export default useStyles
